import {
  MultiFeedTeaseRow,
  MultiFeedTeaseColumn,
} from "design-system/components/blocks/multi-feed-tease-row/multi-feed-tease-row";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { MultiFeedTeaseRowEntry } from "frontend/contentful/schema/blocks";
import { createMultiFeedTeaseColumnProps } from "./multi-feed-tease-column.props";
import { useMultiSearch } from "frontend/hooks/use-search";
import { createUseSearchProps } from "../../utils/use-search.props";
import { createSearchArticleTease } from "frontend/contentful/search/search-article-tease";
import { useContentful } from "frontend/hooks/use-contentful";
import { LegacySearchHit } from "frontend/types";

interface MultiFeedTeaseRowOptions {
  headerAbove?: boolean;
}

export const ContentfulMultiFeedTeaseRow = createContentfulComponent<
  MultiFeedTeaseRowEntry,
  MultiFeedTeaseRowOptions
>(({ entry, options }) => {
  const { getEntries } = useContentful();
  const headerAbove = options?.headerAbove ?? false;

  const feedColumns = getEntries(entry.fields.feedColumns);

  const { data } = useMultiSearch<LegacySearchHit>(
    feedColumns.map((column) => createUseSearchProps(column.fields.query)),
    { dedupe: true, defaultSize: 3 },
  );

  const columns: Array<MultiFeedTeaseColumn> = [];

  feedColumns.forEach((column, i) => {
    const props = createMultiFeedTeaseColumnProps(column);
    if (props) {
      data?.[i]?.hits.forEach((result) => {
        const tease = createSearchArticleTease(result);
        if (tease) props.articles.push(tease);
      });

      columns.push(props);
    }
  });

  return <MultiFeedTeaseRow columns={columns} hasHeader={headerAbove} />;
});
